var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"border":"left","outlined":"","type":_vm.type,"value":true,"icon":"mdi-alert-circle","transition":"scale-transition","dismissible":""}},[_c('h4',{staticClass:"grow"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }